import React from 'react';
import { MapPin, Phone, Clock, Mail, MessageCircle } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function Contact() {
  const {
    t
  } = useTranslations();
  return <section id="contact" className="py-10 bg-gradient-to-br from-white to-[#f0faf4]" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-51">
          {/* Left Side - Chat Info */}
          <div className="flex items-center justify-center order-1 lg:order-1" data-id="element-52">
            <p className="text-sm text-gray-600 text-center" data-id="element-53">
              Para chatear con un especialista, haz clic en el ícono de chat 💬
            </p>
          </div>

          {/* Right Side - Info */}
          <div className="text-center lg:text-center order-2 lg:order-2" data-id="element-54">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-55">
              Empresa
            </h2>

            <div className="grid grid-cols-2 gap-6" data-id="element-56">
              {/* Address */}
              <div className="flex flex-col items-center gap-2" data-id="element-57">
                <div className="w-11 h-11 rounded-lg bg-red-100 flex items-center justify-center" data-id="element-58">
                  <MapPin className="w-5 h-5 text-red-500" data-id="element-59" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-60">Dirección</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-61">
                  390 NE 191st St
                  <br data-id="element-62" />
                  Miami, FL 33179
                </p>
              </div>

              {/* Phone */}
              <div className="flex flex-col items-center gap-2" data-id="element-63">
                <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center" data-id="element-64">
                  <Phone className="w-5 h-5 text-blue-500" data-id="element-65" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-66">Contáctanos</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-67">
                  (786) 272-6132
                  <br data-id="element-68" />
                  Llamadas · WhatsApp
                </p>
              </div>

              {/* Hours */}
              <div className="flex flex-col items-center gap-2" data-id="element-69">
                <div className="w-11 h-11 rounded-lg bg-amber-100 flex items-center justify-center" data-id="element-70">
                  <Clock className="w-5 h-5 text-amber-500" data-id="element-71" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-72">Horarios</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-73">
                  Lun a Sáb: 9am a 9pm
                  <br data-id="element-74" />
                  Dom: Cerrado
                </p>
              </div>

              {/* Email */}
              <div className="flex flex-col items-center gap-2" data-id="element-75">
                <div className="w-11 h-11 rounded-lg bg-purple-100 flex items-center justify-center" data-id="element-76">
                  <Mail className="w-5 h-5 text-purple-500" data-id="element-77" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-78">Soporte</h4>
                <p className="text-[11px] text-gray-500 text-center" data-id="element-79">
                  info@brixenfunding.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}